module.exports = __webpack_public_path__ + "img/provider2.858f7cd1.png";